import HOCInput from 'components/common/hoc-input';
import { Input } from 'components/elements';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

export default function InformationField() {
  const { t } = useTranslation();

  return (
    <FullContainer>
      <HOCInput keys={['number']}>
        {({ number }) =>
          number ? (
            <SectionContainer>
              <HalfContainer>
                <Input
                  type="text"
                  name="number"
                  label={t('common:number')}
                  placeholder={t('common:number')}
                  disabled
                />
              </HalfContainer>
            </SectionContainer>
          ) : (
            <></>
          )
        }
      </HOCInput>

      <SectionContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="requestedAt"
            label={t('refund:requested_at')}
            placeholder={t('refund:requested_at')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="reason"
            label={t('common:reason')}
            placeholder={t('common:reason')}
            required
          />
        </HalfContainer>
      </SectionContainer>
    </FullContainer>
  );
}
